import { useState } from "react";
import { Menu, X } from "lucide-react";

const LINKS = [
  { href: "#inicio", label: "Início", testid: "nav-link-inicio" },
  { href: "#acomodacoes", label: "Acomodações", testid: "nav-link-acomodacoes" },
  { href: "#decoracao", label: "Decoração Romântica", testid: "nav-link-decoracao" },
  { href: "#faq", label: "Dúvidas", testid: "nav-link-faq" },
  { href: "#contato", label: "Contato", testid: "nav-link-contato" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="fixed top-0 inset-x-0 z-50 bg-[#1b4332]/95 backdrop-blur-md shadow-lg" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 flex items-center justify-between h-16">
        <a href="#inicio" className="flex items-center gap-3" data-testid="header-logo">
          <img src="/logo.jpg" alt="Vila Gramado" className="h-11 w-11 rounded-full object-cover ring-2 ring-[#d4a373]" />
          <span className="text-[#f5f0eb] font-bold tracking-wide text-lg">VILA GRAMADO</span>
        </a>
        <nav className="hidden md:flex items-center gap-7">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.testid}
              className="text-[#f5f0eb]/85 hover:text-[#d4a373] text-sm font-bold uppercase tracking-wider transition-colors duration-200"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <button
          className="md:hidden text-[#f5f0eb]"
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-toggle"
          aria-label="Menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>
      {open && (
        <nav className="md:hidden bg-[#1b4332] border-t border-[#40916c]/40 px-6 py-4 flex flex-col gap-4">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`${l.testid}-mobile`}
              onClick={() => setOpen(false)}
              className="text-[#f5f0eb]/90 text-sm font-bold uppercase tracking-wider"
            >
              {l.label}
            </a>
          ))}
        </nav>
      )}
    </header>
  );
};
